import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import IndividualsTopBar from "../../components/IndividualsTopBar";
import TableFooter from "../../components/TableFooter";
import all from "../../images/all.png";
import desc from "../../images/desc.png";
import asc from "../../images/asc.png";
import { CgArrowUp, CgArrowDown } from "react-icons/cg";
import { TbFilterX } from "react-icons/tb";

import ViewSecuritiesModal from "./ViewSecuritiesModal";

import { createColumnHelper } from "@tanstack/react-table";
import TableComponent from "../../components/TableComponent";
import { sideBarContext } from "../../App";

// redux imports
import { useSelector, useDispatch } from "react-redux";
import { updateSortName, updateSortOrder } from "../../redux/slices/sortSlice";
import { decryptText } from "../../utils/cipherText";
const Individuals = () => {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);

  const navigate = useNavigate();
  const sortRef = useRef(null);
  const sortDivRef = useRef(null);
  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [showUserDetails, setShowUserDetails] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [searchPages, setSearchPages] = React.useState();
  const [searchRows, setSearchRows] = React.useState();
  const [filterShow, setFilterShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("name");
  const [imageLoading, setImageLoading] = useState(false);
  const [searchEmpty, setSearchEmpty] = useState(false);
  const storedPage = parseInt(sessionStorage.getItem("currentPage"), 10) || 1;
  const storedSearch = sessionStorage.getItem("query") || "";
  const [pageNo, setPageNo] = React.useState(storedPage);
  const [searchQuery, setSearchQuery] = React.useState(
    useSelector((state) => state.search.individualSearch)
  );
  const [openAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [advancedOptionSelected, setAdvancedOptionSelected] = useState("");
  const [advancedStartDate, setAdvancedStartDate] = useState("");
  const [advancedEndDate, setAdvancedEndDate] = useState("");
  const [advancedSelectValue, setAdvancedSelectValue] = useState("");
  const [advancedEnterValue, setAdvancedEnterValue] = useState("");
  const sortStates = ["", "asc", "desc"];
  const sortTypeRedux = useSelector((state) => state.sort.individualsSortName);
  const sortOrderRedux = useSelector(
    (state) => state.sort.individualsSortOrder
  );
  const [sortType, setSortType] = useState(sortTypeRedux || "");
  const [sortBy, setSortBy] = useState(sortOrderRedux || sortStates[0]);
  const dispatch = useDispatch();
  const [openSorting, setOpenSorting] = useState(false);
  const [ViewSecurities, setViewSecurities] = useState(false);
  const [name, setName] = useState("");
  const [orderArray, setOrderArray] = useState([]);
  const scrollRef = useRef(null);
  const { expanded } = useContext(sideBarContext);
  const columnHelper = createColumnHelper();
  const [leafColumns, setLeafColumns] = useState([]);
  const [loanType, setLoanType] = useState("");
  const [columnSettings, setColumnSettings] = useState(false);
  const columns = [
    columnHelper.accessor((row, index) => index + 1, {
      id: "index",
      cell: (info) => info.row.index + 1 + startIndex,
      header: () => "#",
      static: true,
      enableHiding: false,
      enableSorting: false,
      size: 30,
    }),
    columnHelper.accessor("name", {
      id: "name",
      cell: (info) => truncateText(info.getValue(), 20),
      header: () => (
        <SortTableButton
          title={"Name"}
          param={"user_name_"}
          handleSort={handleSort}
          sortType={sortType}
          sortBy={sortBy}
          side={"left"}
          openSorting={openSorting}
          setOpenSorting={setOpenSorting}
          setSortType={setSortType}
          setSortBy={setSortBy}
          sortRef={sortRef}
          sortDivRef={sortDivRef}
        />
      ),
      enableHiding: false,
      enableSorting: false,
      size: 180,
    }),
    columnHelper.accessor("customer_id", {
      id: "customer_id",
      cell: (info) => info.getValue(),
      header: () => "Customer ID",
      enableSorting: false,
    }),
    columnHelper.accessor("phone", {
      id: "phone",
      cell: (info) => info.getValue(),
      header: () => "Phone Number",
      enableSorting: false,
    }),
    columnHelper.accessor("od_account_no", {
      id: "od_account_no",
      cell: (info) => info.getValue(),
      header: () => "OD Account No",
      enableSorting: false,
    }),
    columnHelper.accessor("user_created", {
      id: "user_created",
      cell: (info) => info.getValue(),
      header: () => (
        <SortTableButton
          title={"User Creation Date"}
          param={"creation_date_"}
          handleSort={handleSort}
          sortType={sortType}
          sortBy={sortBy}
          side={"left"}
          openSorting={openSorting}
          setOpenSorting={setOpenSorting}
          setSortType={setSortType}
          setSortBy={setSortBy}
          sortRef={sortRef}
          sortDivRef={sortDivRef}
        />
      ),
      enableSorting: false,
      size: 200,
    }),
    columnHelper.accessor("current_loan_step", {
      id: "current_step",
      cell: (info) => info.getValue(),
      header: () => "Current Step",
      enableSorting: false,
    }),
    columnHelper.accessor("pledged_amount", {
      id: "pledged_amount",
      cell: (info) => formatToIndianRupees(info.getValue()),
      header: () => "Pledged Amount",
      enableSorting: false,
      enableHiding: false,
    }),
    columnHelper.accessor("disbursed_amount", {
      id: "disbursed_amount",
      cell: (info) => formatToIndianRupees(info.getValue()),
      header: () => "Availed Amount",
      enableSorting: false,
    }),
    columnHelper.accessor("fetched_asset_value", {
      id: "total_holdings",
      cell: (info) => formatToIndianRupees(info.getValue()),
      header: () => (
        <SortTableButton
          title={"Total Holdings"}
          param={"total_asset_value_"}
          handleSort={handleSort}
          sortType={sortType}
          sortBy={sortBy}
          side={"left"}
          openSorting={openSorting}
          setOpenSorting={setOpenSorting}
          setSortType={setSortType}
          setSortBy={setSortBy}
          sortRef={sortRef}
          sortDivRef={sortDivRef}
        />
      ),
      enableSorting: false,
    }),
    columnHelper.accessor("utilization_ratio", {
      id: "utilization_ratio",
      cell: (info) => (info.getValue() === "NA" ? "NA" : info.getValue() + "%"),
      header: () => "Utilization Ratios",
      enableSorting: false,
    }),

    columnHelper.accessor("security_detail", {
      id: "view_securities",
      header: "Securrity Details",
      cell: ({ row }) => {
        const securityDetail = row.original.security_detail;
        const name = row.original.name;

        return (
          <button
            className="underline text-[#0070d2]"
            onClick={(e) => {
              e.stopPropagation();
              setName(name);
              setOrderArray(securityDetail);
              setViewSecurities(true);
            }}
          >
            View Securities
          </button>
        );
      },
      enableSorting: false,
    }),
    // columnHelper.accessor("Status", {
    //   id: "status",
    //   cell: (info) => (
    //     <span className=" py-1 px-2 bg-[#dbe8d8] text-[#218838] rounded-[13px]">
    //       Accepted
    //     </span>
    //   ),
    //   header: () => "Status",
    // }),
  ];

  const [visibleColumns, setVisbleColumns] = useState(
    localStorage.getItem("individualsTableData")
      ? JSON.parse(localStorage.getItem("individualsTableData")).visible
      : {}
  );
  //////
  const [columnOrder, setColumnOrder] = useState(() =>
    localStorage.getItem("individualsTableData")
      ? JSON.parse(localStorage.getItem("individualsTableData")).order
      : columns.map((c) => c.id)
  );
  const [userStepFilter, setUserStepFilter] = useState("");
  const fetchUsers = async (controller, flag) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      if (flag) {
        const res = await axios.request(
          `${
            process.env.REACT_APP_URL
          }/lender/asset_index?page=${pageNo}&rows_per_page=${rowsPerPage}&page_name=asset&sort_by=${
            sortBy ? sortType + sortBy : ""
          }`,
          options
        );

        setList(res.data.user_details);
        setTotalPages(res.data.total_pages);
        setTotalRows(res.data.total_entries);
        setSearchList([]);
        scrollContent();
      } else {
        const res = await axios.request(
          `${
            process.env.REACT_APP_URL
          }/lender/asset_index?page=${pageNo}&rows_per_page=${rowsPerPage}&page_name=asset&filter_by=${advancedOptionSelected}&start_date=${advancedStartDate}&end_date=${advancedEndDate}&asset_filter=${advancedSelectValue}&credit_type=${loanType}&value=${advancedEnterValue}&sort_by=${
            sortBy ? sortType + sortBy : ""
          }${userStepFilter ? `&step=${userStepFilter}` : ""}`,
          options
        );
        setTotalPages(res.data.total_pages);
        setTotalRows(res.data.total_entries);
        setList(res.data.user_details);
        setSearchList([]);
        scrollContent();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  const handleClick = (id, name, creditType) => {
    let userName = "";
    sessionStorage.setItem("query", searchQuery);
    sessionStorage.setItem("currentPage", pageNo);
    name === null ? (userName = "") : (userName = name);
    navigate(
      `/individuals/${id}?name=${userName}&od=${
        creditType === "Bajaj" ? true : false
      }`
    );
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: {
        Authorization: token,
      },
    };
    try {
      axios
        .request(`${process.env.REACT_APP_URL}/lender/users/${id}`, options)
        .then((response) => {
          setShowUserDetails(response.data.user_details);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const executeClickFunction = (singleRow) => {
    if (userType === "distributors") return;
    handleClick(singleRow.id, singleRow.name, singleRow.credit_type);
  };

  const fetchAdvancedFilters = async () => {
    if (searchQuery) {
      const controller = new AbortController();
      fetchSearchedUsers(controller, false);
      setOpenAdvancedFilter(false);
      return;
    }
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      // signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${
          process.env.REACT_APP_URL
        }/lender/asset_index?page=${pageNo}&rows_per_page=${rowsPerPage}&page_name=asset&filter_by=${advancedOptionSelected}&start_date=${advancedStartDate}&end_date=${advancedEndDate}&asset_filter=${advancedSelectValue}&value=${advancedEnterValue}&sort_by=${
          sortBy ? sortType + sortBy : ""
        }`,
        options
      );
      setTotalPages(res.data.total_pages);
      setTotalRows(res.data.total_entries);
      setList(res.data.user_details);
      setOpenAdvancedFilter(false);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const clearAdvancedFilters = () => {
    setLoanType("");
    setAdvancedOptionSelected("");
    setAdvancedStartDate("");
    setAdvancedEndDate("");
    setAdvancedSelectValue("");
    setAdvancedEnterValue("");
    setOpenAdvancedFilter(false);
    sessionStorage.removeItem("currentPage");
    const controller = new AbortController();
    if (searchQuery) {
      fetchSearchedUsers(controller, true);
      return;
    }
    fetchUsers(controller, true);
    return () => {
      controller.abort();
    };
  };

  const fetchSearchedUsers = async (controller, flag) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");

    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      if (flag) {
        const res = await axios.request(
          `${
            process.env.REACT_APP_URL
          }/lender/asset_search?filters=${searchQuery}&page=${pageNo}&rows_per_page=${rowsPerPage}&sort_by=${
            sortBy ? sortType + sortBy : ""
          }${userStepFilter ? `&step=${userStepFilter}` : ""}`,
          options
        );

        // setList(res.data.user_details);
        if (res.data.user_details.length < 1) {
          setSearchEmpty(true);
          setSearchList([]);
        }
        if (res.data.user_details.length > 0) {
          setSearchEmpty(false);
          setList([]);
          setSearchList(res.data.user_details);
        }
        setSearchPages(res.data.total_pages);
        setSearchRows(res.data.total_entries);
      } else {
        const res = await axios.request(
          `${
            process.env.REACT_APP_URL
          }/lender/asset_search?filters=${searchQuery}&page=${pageNo}&rows_per_page=${rowsPerPage}&filter_by=${advancedOptionSelected}&start_date=${advancedStartDate}&end_date=${advancedEndDate}&credit_type=${loanType}&asset_filter=${advancedSelectValue}&value=${advancedEnterValue}&sort_by=${
            sortBy ? sortType + sortBy : ""
          }`,
          options
        );

        // setList(res.data.user_details);
        if (res.data.user_details.length < 1) {
          setSearchEmpty(true);
          setSearchList([]);
        }
        if (res.data.user_details.length > 0) {
          setSearchEmpty(false);

          setSearchList(res.data.user_details);
          setList([]);
        }
        setSearchPages(res.data.total_pages);
        setSearchRows(res.data.total_entries);
      }
      setImageLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("query");
    const controller = new AbortController();
    if (searchQuery !== "") {
      setPageNo(1);
      setList([]);
      fetchSearchedUsers(controller, false);
    }
    if (searchQuery === "") {
      setSearchList([]);
      fetchUsers(controller, false);
      setSearchEmpty(false);
    }
    return () => {
      controller.abort();
    };
  }, [searchQuery, pageNo, rowsPerPage, sortBy]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);

  const displayedRows = list.length > 0 ? list : searchList;
  const noOfRows = list.length > 0 ? totalRows : searchRows;
  const noOfPages = list.length > 0 ? totalPages : searchPages;

  const filterList = ["name", "phone"];
  function capitalize(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  function truncateText(text, maxLength) {
    if (text === null || text === "" || text === undefined) return "---";
    if (text?.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }
  function formatToIndianRupees(num) {
    if (num === null || num === undefined) return "---";
    // Convert the number to a string
    if (num === null) return "---";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  const handleSort = (type) => {
    let byValue = sortStates[(sortStates.indexOf(sortBy) + 1) % 3];

    if (sortType === type && byValue === "") {
      setSortType("");
      setSortBy(byValue);
      return;
    }
    if (sortType !== type) {
      byValue = "asc";
      setSortBy(byValue);
      setSortType(type);
      return;
    }

    setSortBy(byValue);
  };

  const scrollContent = () => {
    if (scrollRef.current) scrollRef.current.scrollLeft = 700;
  };
  const [tempVisibility, setTempVisibility] = useState({
    ...visibleColumns,
  });
  useEffect(() => {
    const timeout = setTimeout(() => {
      try {
        localStorage.setItem(
          "individualsTableData",
          JSON.stringify({
            order: columnOrder,
            visible: visibleColumns,
          })
        );
      } catch (error) {
        console.error("Failed to save table data to localStorage:", error);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [visibleColumns, columnOrder]);

  //save sort data to redux
  useEffect(() => {
    dispatch(updateSortName(sortType));
    dispatch(updateSortOrder(sortBy));
  }, [sortType, sortBy]);

  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px]`}
    >
      <div className="mt-4 rounded-lg bg-white mb-4 p-4">
        <p className="text-[#262626] text-xl font-semibold">Individuals</p>
      </div>
      <div className=" bg-white px-4 flex flex-col justify-between pt-2 rounded-t-lg">
        <IndividualsTopBar
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          filterList={filterList}
          filterShow={filterShow}
          setFilterShow={setFilterShow}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          openAdvancedFilter={openAdvancedFilter}
          setOpenAdvancedFilter={setOpenAdvancedFilter}
          advancedOptionSelected={advancedOptionSelected}
          setAdvancedOptionSelected={setAdvancedOptionSelected}
          advancedStartDate={advancedStartDate}
          setAdvancedStartDate={setAdvancedStartDate}
          advancedEndDate={advancedEndDate}
          setAdvancedEndDate={setAdvancedEndDate}
          fetchAdvancedFilters={fetchUsers}
          clearAdvancedFilters={clearAdvancedFilters}
          advancedSelectValue={advancedSelectValue}
          setAdvancedSelectValue={setAdvancedSelectValue}
          advancedEnterValue={advancedEnterValue}
          setAdvancedEnterValue={setAdvancedEnterValue}
          downloadPageWord="assets"
          tempVisibility={tempVisibility}
          setTempVisibility={setTempVisibility}
          setVisibleColumns={setVisbleColumns}
          leafColumns={leafColumns}
          loanType={loanType}
          setLoanType={setLoanType}
          columnSettings={columnSettings}
          setColumnSettings={setColumnSettings}
          setUserStepFilter={setUserStepFilter}
        />
      </div>
      {!showUserDetails ? (
        <div className=" px-2 bg-white rounded-b-lg  enable-scrollbar-x ">
          <TableComponent
            list={displayedRows}
            imageLoading={imageLoading}
            columns={columns}
            visibleColumns={visibleColumns}
            setLeafColumns={setLeafColumns}
            handleClick={executeClickFunction}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
            setColumnSettings={setColumnSettings}
            pinnedColumns={["index", "name", "pledged_amount"]}
          />
          <TableFooter
            totalPages={noOfPages}
            totalRows={noOfRows}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            endIndex={endIndex}
            setStartIndex={setStartIndex}
            setEndIndex={setEndIndex}
            setPageNo={setPageNo}
            pageNo={pageNo}
            setRowsPerPage={setRowsPerPage}
          />
        </div>
      ) : (
        <></>
      )}
      {ViewSecurities && (
        <ViewSecuritiesModal
          cancelFunction={setViewSecurities}
          name={name}
          orderArray={orderArray}
        />
      )}
    </div>
  );
};

export default Individuals;

const SortTableButton = ({
  title,
  handleSort,
  sortBy,
  sortType,
  param,
  side,
  openSorting,
  setOpenSorting,
  setSortType,
  setSortBy,
  sortRef,
  sortDivRef,
}) => {
  return (
    <button
      className=" flex items-center relative"
      ref={sortRef}
      onClick={() => {
        if (sortType !== param) {
          setSortBy("");
          setSortType(param);
        }

        if (!openSorting || sortType !== param) {
          setOpenSorting(true);
        } else if (openSorting && sortType === param) {
          setOpenSorting(false);
        }
      }}
    >
      {openSorting && sortType === param && (
        <div
          ref={sortDivRef}
          className={`w-[162px] px-2 rounded-lg absolute top-5  z-[10] bg-white text-xs font-medium shadow-md py-2 !opacity-100 ${
            sortType === "total_asset_value_" || sortType === "user_name_"
              ? " -left-[40px]"
              : " right-[2px]"
          }`}
        >
          <div
            className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
              sortBy === "asc" && "bg-[#A0FF77]"
            }`}
            onClick={() => {
              setSortBy("asc");
              setOpenSorting(false);
            }}
          >
            <CgArrowUp size={"15px"} /> Sort Ascending
          </div>
          <div
            className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] mt-2 pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
              sortBy === "desc" && "bg-[#A0FF77]"
            }`}
            onClick={() => {
              setSortBy("desc");
              setOpenSorting(false);
            }}
          >
            <CgArrowDown size={"15px"} /> Sort Descending
          </div>
          {sortBy && (
            <div className="flex flex-row justify-center items-center w-full">
              <button
                type="button"
                className="py-[3px] px-2 rounded w-[73px] h-6 font-medium  text-[#00394d] border border-[#00394d] mt-3 flex flex-row justify-center items-center gap-2"
                onClick={() => {
                  setSortBy("");
                  setSortType("");
                  setOpenSorting(false);
                }}
              >
                <TbFilterX size={"15px"} /> Clear
              </button>
            </div>
          )}
        </div>
      )}
      {side === "left" && title}
      <span
        className={`${side === "left" ? " ml-2 " : " mr-2 "}  ${
          sortType === param && sortBy !== "" ? "visible" : "visible"
        }`}
      >
        {/* <IoArrowDownSharp
          className=" w-4 h-4 "
          style={{
            transform: sortBy === "asc" && "rotate(180deg)",
          }}
        /> */}
        {sortType === param && sortBy === "asc" ? (
          <img src={asc} alt="sort" className="" />
        ) : sortType === param && sortBy === "desc" ? (
          <img src={desc} alt="sort" className="" />
        ) : (
          <img src={all} alt="sort" className="" />
        )}
      </span>
      {side === "right" && title}
    </button>
  );
};
